import { render, staticRenderFns } from "./RecentActivity.vue?vue&type=template&id=6f0a0128&scoped=true&"
import script from "./RecentActivity.vue?vue&type=script&lang=js&"
export * from "./RecentActivity.vue?vue&type=script&lang=js&"
import style0 from "./RecentActivity.vue?vue&type=style&index=0&id=6f0a0128&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a0128",
  null
  
)

export default component.exports